import * as React from "react";
import { forwardRef } from "react";
const SvgUser = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", width: 24, height: 24, strokeWidth: 1, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" }), /* @__PURE__ */ React.createElement("path", { d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" }));
const ForwardRef = forwardRef(SvgUser);
export default ForwardRef;
